export const SET_AUTH_USER = 'SetAuthUser';
export const LOG_OUT = 'LogOut';
export const GET_Q = 'GetQ';
export const ADD_Q = 'AddQ';
export const ADD_ANS = 'AddAns';
export const GET_USER = 'GetUser';



// WEBPACK FOOTER //
// ./src/actions/actionTypes.js